import { useEffect, useState } from "react";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Bookshelf } from "@/components/Bookshelf";
import { AuthProvider } from "@/context/AuthContext";
import { Reader } from "@/components/Reader";
import { Toaster } from "sonner";

const About = () => (
  <section id="about" data-testid="about-section" className="border-t border-border">
    <div className="mx-auto grid max-w-6xl gap-10 px-6 py-24 md:grid-cols-[1fr_2fr]">
      <p className="text-xs uppercase tracking-[0.3em] text-primary">About the archive</p>
      <div className="space-y-5">
        <p className="max-w-2xl text-base leading-relaxed text-muted-foreground md:text-lg">
          The Avali Archive preserves the shelved memory of Avalon: expedition
          journals, recovered data shards, and the great indices of the Oracle.
          Every tome here is a facsimile, bound page by page, and read the way
          the packs intended — leafed through, image by image, in the warm dark.
        </p>
        <p className="max-w-2xl text-sm leading-relaxed text-muted-foreground">
          Each tome lives in its own folder of plates, catalogued by a cache
          manifest that shares its name. New tomes appear on the shelf as soon
          as their folder is archived.
        </p>
      </div>
    </div>
  </section>
);

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-border">
    <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-4 px-6 py-8">
      <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground">avali-archive.space</p>
      <p className="text-xs text-muted-foreground">Bound in ice and light. All tomes are demo facsimiles.</p>
    </div>
  </footer>
);

function App() {
  const [theme, setTheme] = useState(() => localStorage.getItem("avali-theme") || "dark");
  const [pageTurn, setPageTurn] = useState(() => localStorage.getItem("avali-page-turn") || "flip");
  const [showProgress, setShowProgress] = useState(() => localStorage.getItem("avali-progress") !== "off");
  const [activeBook, setActiveBook] = useState(null);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("avali-theme", theme);
  }, [theme]);
  useEffect(() => localStorage.setItem("avali-page-turn", pageTurn), [pageTurn]);
  useEffect(() => localStorage.setItem("avali-progress", showProgress ? "on" : "off"), [showProgress]);

  return (
    <AuthProvider>
    <div className="min-h-screen bg-background text-foreground">
      <Header
        theme={theme}
        setTheme={setTheme}
        pageTurn={pageTurn}
        setPageTurn={setPageTurn}
        showProgress={showProgress}
        setShowProgress={setShowProgress}
      />
      <main>
        <Hero />
        <Bookshelf onOpenBook={setActiveBook} />
        <About />
      </main>
      <Footer />
      {activeBook && (
        <Reader
          book={activeBook}
          onClose={() => setActiveBook(null)}
          pageTurn={pageTurn}
          showProgress={showProgress}
        />
      )}
      <Toaster richColors position="bottom-right" />
    </div>
    </AuthProvider>
  );
}

export default App;
